export const INITIAL_VALUE = 'flexbox';

const CODE = {
  flexbox: `\
.container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.element {
  width: 50%;
  height: 50%;
}`,
  grid: `\
.container {
  display: grid;
  place-content: center;
}

.element {
  width: 50%;
  height: 50%;
}`,
};

export function constructSnippet(
  layoutMode: keyof typeof CODE = INITIAL_VALUE
) {
  return CODE[layoutMode];
}
